<template lang="pug">
    layout.contentTransparent(fluid)

        // Title
        title-component(
            :title="$t('landingPages.list.title')"
            slot="title"
            type="h2"
        )

        template
            v-layout(row wrap justify-space-between)
                v-flex(xs12)
                    div.createButtonWrapper

                        // Create Business button
                        button-component.mx-0.my-0(
                            :action="addLandingPage"
                            color="action"
                            large
                        ) {{ isMobile ? $t('landingPages.list.createButtonMobile') : $t('landingPages.list.createButton') }}

            separator-component.overlay

            v-layout(row wrap)
                v-flex(xs12)

                    // Businesses list (Mobile)
                    v-data-table.c-table(
                        v-if="isMobile"
                        :headers-length="3"
                        :items="items"
                        :loading="isLoading"
                        :pagination.sync="pagination"
                        :total-items="total"
                        :rowsPerPageItems="[12]"
                    )
                        template(
                            v-slot:items="props"
                        )
                            tr(@click="props.expanded = !props.expanded")
                                list-mobile(
                                    :item="props.item"
                                    :expanded="props.expanded"
                                )
                                    item-actions( :item="props.item" @removed="resetPagination")

                        template(slot="expand" slot-scope="props")
                            tr
                                td(colspan="6")
                                    expand-card(:item="props.item")

                    // Coupons list (Desktop)
                    v-data-table.c-table(
                        v-if="!isMobile"
                        :headers="headers"
                        :items="items"
                        :loading="isLoading"
                        :pagination.sync="pagination"
                        :total-items="total"
                        :rowsPerPageItems="[12]"
                    )

                        template(slot="items" slot-scope="props")
                            list-item(:item="props.item")
                                item-actions(:item="props.item" @removed="resetPagination")
</template>

<script>
    import Layout from '../../Layout/Layout';
    import ListItem from './ListItem';
    import ListMobile from './ListItemMobile';
    import ExpandCard from './ExpandCard';
    import Button from '~components/Button';
    import Filter from '~components/Filter';
    import Separator from '~components/Separator';
    import Title from '~components/Title';
    import { landingPages } from '~api';
    import ListItemActions from './ListItemActions';

    export default {
        components: {
            Layout,
            ListItem,
            ListMobile,
            ExpandCard,
            TitleComponent: Title,
            ButtonComponent: Button,
            FilterComponent: Filter,
            SeparatorComponent: Separator,
            ItemActions: ListItemActions
        },
        data() {
            return {
                headers: this.$t('landingPages.tableHeaders'),
                items: [],
                pagination: {},
                isLoading: false,
                total: 0,
                rowsPerPage: [10]
            };
        },
        /**
         * Retrieve managers
         */
        async beforeRouteEnter(to, from, next) {
            // Fetch data from API.
            const { data } = await landingPages.list();

            next(vm => {
                vm.items = data.items;

                vm.total = data.meta && data.meta.total ? data.meta.total : 0;

                vm.pagination = {
                    page: data.meta && data.meta.page ? data.meta.page : 0,
                    rowsPerPage:
                        data.meta && data.meta.limit ? data.meta.limit : 0
                };

                vm.$nextTick(() => {
                    vm.routeInitialized = true;
                });
            });
        },
        computed: {
            // Check screen resolution
            isMobile() {
                return this.$vuetify.breakpoint.smAndDown;
            }
        },

        watch: {
            /**
             * Watch pagination and update managers data on change
             */
            pagination: {
                async handler(paginationData) {
                    if (!this.routeInitialized) {
                        return;
                    }

                    // Start progress bar.
                    this.isLoading = true;

                    // Collect params.
                    const params = {
                        page: paginationData.page
                    };
                    // Fetch data from API.
                    const { data } = await landingPages.list(params);

                    this.items = data.items;
                    this.total =
                        data.meta && data.meta.total ? data.meta.total : 0;

                    // Stop progress bar.
                    this.isLoading = false;
                },
                deep: true
            }
        },
        methods: {
            addLandingPage() {
                this.$router.push({ name: 'dashboard.pages.create' });
            },
            /**
             * Reset pagination.
             */
            resetPagination() {
                this.pagination = { ...this.pagination };
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'

    .createButtonWrapper
        display: flex
        justify-content: flex-end

    .text-left
        text-align: left

    .ceilText
        display: inline-block

    >>> .actions
        min-width: 90px

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .createButtonWrapper
            .btn
                width: 100%
</style>
